export const showCover = function () {
  const board = this.model.getBoard();
  return (
    // Assume board is nullable since it can't be retrieved sometimes
    board?.getPref('cardCovers') && this.model.hasCover() && !this.onCalendar
  );
};
